import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from 'material-ui/Snackbar';

class Toast extends React.Component {

    getBodyStyle(type) {
        switch (type) {
            case 'error':
                return styles.snackbarError;

            case 'info':
                return styles.snackbarInfo;

            case 'success':
                return styles.snackbarSuccess;

            default:
                return styles.snackbarInfo;
        }
    }

    render() {
        const {
            onRequestClose,
            snackbarOpen,
            snackbarText,
            snackbarType,
            onActionClick,
        } = this.props

        return (
            <Snackbar
                bodyStyle={this.getBodyStyle(snackbarType)}
                style={styles.snackbar}
                open={snackbarOpen}
                message={snackbarText}
                action="ok"
                autoHideDuration={4000}
                onActionClick={onActionClick}
                onRequestClose={onRequestClose}
            />
        );
    }
}

Toast.propTypes = {
    snackbarOpen: PropTypes.bool.isRequired,
    snackbarText: PropTypes.string.isRequired,
    snackbarType: PropTypes.string.isRequired,
    onActionClick: PropTypes.func.isRequired,
};

Toast.defaultProps = {
    snackbarType: 'info',
};

const styles = {
    snackbar: {
        left: 'auto',
        right: 0,
        bottom: 'auto',
        top: 0,
        transform: 'none',
        transition: 'none',
        marginTop: 24,
        marginRight: 24,
    },
    snackbarSuccess: {
        background: '#009688',
    },
    snackbarInfo: {
        background: '#000000',
    },
    snackbarError: {
        background: '#F44336',
    },
};

export default Toast;